import styled from 'styled-components';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const Label = styled.span`
    margin-right: 6px;
`;

const InfoIcon = styled(InfoCircleOutlined)`
    color: #b0bac6;
    font-size: 13px;
    cursor: help;
    transition: color 0.15s;

    &:hover {
        color: #1e7a45;
    }
`;

type Props = {
    label?: string;
    tooltip?: string;
};

export const InputLabelWithTooltip = ({ label, tooltip }: Props) => (
    <span>
        <Label>{label}</Label>
        {tooltip && (
            <Tooltip title={tooltip}>
                <InfoIcon />
            </Tooltip>
        )}
    </span>
);
